import styled from 'styled-components';
import { testableStyledComponentConfig } from '@24i/nxg-sdk-gluons';
import { isMobileOnly } from 'react-device-detect';
const gradientHeight = isMobileOnly ? 180 : 320;
const transitionDuration = '200ms';
const buttonMargin = 24;
export const Container = styled.div `
    width: 100%;
    box-sizing: border-box;
    height: ${gradientHeight}px;
    flex-direction: column;
    justify-content: flex-end;
    margin: 0 auto;
    padding: 0 48px;
    display: ${({ shouldBeHidden }) => (shouldBeHidden ? 'none' : 'flex')};
    background-image: ${({ gradient }) => `linear-gradient(to top, ${gradient === null || gradient === void 0 ? void 0 : gradient.colors[0]}, ${gradient === null || gradient === void 0 ? void 0 : gradient.colors[1]})`};
    > * {
        // Setting pointer-events to auto so it works over embedded ad UI
        pointer-events: auto;
    }
`;
export const Time = styled.span.withConfig(testableStyledComponentConfig) `
    color: ${({ theme }) => { var _a; return ((_a = theme === null || theme === void 0 ? void 0 : theme.color) === null || _a === void 0 ? void 0 : _a.textPrimary) || 'white'; }};
    transition: opacity ${transitionDuration}, visibility ${transitionDuration};
    opacity: ${({ isVolumeOpened }) => (isVolumeOpened ? 0 : 1)};
    visibility: ${({ isVolumeOpened }) => (isVolumeOpened ? 'hidden' : 'visible')};
`;
export const FooterStart = styled.div `
    flex: 1;
    display: flex;
    align-items: center;
    justify-content: flex-start;
`;
FooterStart.displayName = 'FooterStart';
export const FooterMiddle = styled.div `
    flex: 1;
    display: flex;
    align-items: center;
    justify-content: space-around;
`;
FooterMiddle.displayName = 'FooterMiddle';
export const FooterEnd = styled.div `
    flex: 1;
    display: flex;
    align-items: center;
    justify-content: flex-end;
    flex-direction: row;
`;
FooterEnd.displayName = 'FooterEnd';
export const RemainingTimeContainer = styled.div `
    width: 100px;
    display: flex;
    justify-content: flex-end;
`;
RemainingTimeContainer.displayName = 'RemainingTimeContainer';
export const ElapseTimeContainer = styled.div `
    width: 100px;
    display: flex;
    justify-content: flex-start;
`;
ElapseTimeContainer.displayName = 'ElapseTimeContainer';
export const rightMarginButtonStyles = {
    button: {
        marginRight: buttonMargin,
    },
};
export const leftMarginButtonStyles = {
    button: {
        marginLeft: buttonMargin,
    },
};
//# sourceMappingURL=index.js.map